import { ChevronRightIcon, CopyIcon } from "@chakra-ui/icons";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Button as CButton,
  CircularProgress,
  Container,
  Grid,
  Heading,
  HStack,
  IconButton,
  Stack,
  Text,
  useDisclosure,
  useToast,
  VStack,
} from "@chakra-ui/react";
import StarBorderIcon from "@material-ui/icons/Star";
import Rating from "@material-ui/lab/Rating";
import { ReactComponent as FileIcon } from "assets/svg/fileIcon.svg";
import { ReactComponent as MessengerIcon } from "assets/svg/messenger.svg";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import Button from "components/Button/Button";
import Header from "components/dashHeader";
import Messanger from "components/Messager/Messanger";
import ConfirmationModal from "components/Modals/p2p/Confirmation";
import UploadProve from "components/Modals/p2p/UploadProve";
// import SuccessModal from "components/Modals/Success";
import Sidemenu from "components/sidemenu";
import constant from "config/constant";
import { format, parseISO } from "date-fns";
import useMinsCountDown from "hooks/useMinsCountDown";
import usePusher from "hooks/usePusher";
// import TraderSession from "./P2pBuyMakePayment";
// import TradeOwnerSession from "./ReleaseTradeAsset";
import toLower from "lodash/toLower";
import toUpper from "lodash/toUpper";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  useGetBuyTradeSessionQuery,
  useGetP2PListingUserProfileQuery,
  useRateTradeMutation,
  useUpdateTradeSessionMutation,
} from "services/p2pApi";
import { useStore } from "store";
import { uploadFile } from "util/do";
import formatter from "util/formatter";
import ls from "util/secureStorage";
import { floatString } from "util/utils";

import useCopy from "hooks/useCopy";
import UserPopover from "components/UserPopover/UserPopover";

function useTradeInitiatorInfo(trade) {
  const initiator = useMemo(() => {
    if (trade?.adsType === "selling")
      return trade?.counterParties?.find((c) => c?.perspective === "buyer")
        ?.user;
    if (trade?.adsType === "buying")
      return trade?.counterParties?.find((c) => c?.perspective === "seller")
        ?.user;
  }, [trade]);

  const { data: listingOwnerProfile, isLoading: isFetchingInitiatorProfile } =
    useGetP2PListingUserProfileQuery(`${initiator?.username}`, {
      skip: !initiator?.username,
    });

  const initiatorProfile = useMemo(
    () => listingOwnerProfile?.profile,
    [listingOwnerProfile]
  );

  const initiatorName = useMemo(
    () =>
      [
        initiatorProfile?.userData?.firstName,
        initiatorProfile?.userData?.lastName,
      ].join(" "),
    [initiatorProfile]
  );

  return {
    initiator,
    initiatorUsername: initiator?.username,
    initiatorProfile,
    initiatorName,
    isFetchingInitiatorProfile,
  };
}

const TraderSessionUnpaid = ({
  trader,
  tradeOwner,
  tradeId,
  frozenRef,
  refetch,
}) => {
  const [file, setFile] = useState();
  const [isUploading, setIsUploading] = useState(false);

  const toast = useToast();

  console.log("TRADER", tradeOwner);

  const { timer: countDown } = useMinsCountDown(
    trader?.timeline?.dueAt,
    `${trader?.timeline?.duration}m : 00s`
  );

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: cancelIsOpen,
    onOpen: cancelOnOpen,
    onClose: cancelOnClose,
  } = useDisclosure();

  const {
    isOpen: uploadProveIsOpen,
    onOpen: onOpenUploadProve,
    onClose: onCloseUploadProve,
  } = useDisclosure();

  const [
    _updateTradeSession,
    { isLoading: isUpdating, isSuccess, isError, error },
  ] = useUpdateTradeSessionMutation();

  const updateSession = useCallback(
    (operation, paymentProof = null) =>
      tradeId &&
      frozenRef &&
      _updateTradeSession({
        id: tradeId,
        frozenRef,
        operation,
        paymentProof,
      }),
    [tradeId, frozenRef, _updateTradeSession]
  );

  const getPaymentOptions = () => {
    let options = [];
    trader?.payTo?.forEach((option) => {
      if (
        toLower(option.label) === "external wallet" &&
        option.source === "external" &&
        toLower(option.receivingIntoLabel) === "changera"
      ) {
        options.push({ method: "changeraId", ...option });
      }
      if (
        option.source === "external" &&
        toLower(option.receivingIntoLabel) !== "changera" &&
        option.source === "external" &&
        toLower(option.receivingIntoLabel) !== "bitmama wallet"
      )
        options.push({ method: "bankTransfer", ...option });
    });

    return options;
  };

  const bankDetail =
    trader &&
    getPaymentOptions().filter((option) => option.method === "bankTransfer")[0];

  console.log("PAY TO", bankDetail);

  useEffect(() => {
    if (isSuccess) {
      onCloseUploadProve();
      refetch && refetch();
    }

    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Opps",
        description: error?.data?.error,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [
    isSuccess,
    cancelOnClose,
    isError,
    error,
    toast,
    onCloseUploadProve,
    refetch,
  ]);

  const handlePaid = () => {
    onClose();
    setTimeout(() => onOpenUploadProve(), 100);
  };

  const handleUploadAndConfirmPayment = async () => {
    if (!file) {
      updateSession("CONFIRMPAYMENT");
    } else {
      setIsUploading(true);
      const res = await uploadFile(file);
      updateSession("CONFIRMPAYMENT", res.location);
      console.log("FILE", res);
      setIsUploading(false);
    }
  };

  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Bank Details</Heading>

        <HStack mt="18px" direction="row" gridGap="100px">
          <VStack alignItems="flex-start">
            <Text color="#4E4B66" fontSize="sm" mt="0px !important">
              Name
            </Text>
            <Text color="#4E4B66" fontSize="sm" mt="18px !important">
              Bank
            </Text>
            <Text color="#4E4B66" fontSize="sm" mt="18px !important">
              Account no.
            </Text>
          </VStack>

          <VStack alignItems="flex-start">
            <HStack mt="0px !important">
              <UserPopover
                user={tradeOwner?.user}
                label={bankDetail?.accountName}
              />
              {/* <Text fontSize="sm" mt="0 !important">
                {bankDetail?.accountName}
              </Text> */}
              <IconButton
                size="xs"
                variant="ghost"
                aria-label="copy"
                icon={<CopyIcon color="#6E7191" />}
                _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
              />
            </HStack>

            <HStack mt="16px !important">
              <Text fontSize="sm" mt="0 !important">
                {/* Guaranty Trust Bank */}
                {bankDetail?.receivingIntoLabel}
              </Text>
              <IconButton
                size="xs"
                variant="ghost"
                aria-label="copy"
                icon={<CopyIcon color="#6E7191" />}
              />
            </HStack>

            <HStack mt="16px !important" justifyContent="flex-start">
              <Text fontSize="sm">
                {/* 0123456789 */}
                {bankDetail?.receivingIntoAddress}
              </Text>
              <IconButton
                size="xs"
                variant="ghost"
                aria-label="copy"
                icon={<CopyIcon color="#6E7191" />}
              />
            </HStack>
          </VStack>
        </HStack>
      </Box>

      <Stack mt="24px !important">
        <Text fontSize="sm">Time limit</Text>
        <Text fontSize="sm" mt="0 !important" color="#03A438">
          {/* {trader?.timeline?.duration} mins */}
          {countDown}
        </Text>

        <Text mt="32px !important" fontSize="sm" color="#4E4B66">
          Please ensure payment is made within {trader?.timeline?.duration}:00
          mins, else the transaction would be cancelled.
        </Text>
      </Stack>

      <HStack
        mt="40px !important"
        pb="40px"
        justifyContent="center"
        gridGap="20px"
      >
        <Button
          // h="56px"
          onClick={cancelOnOpen}
          minW="120px !important"
          // px="10px"
          bg="transparent"
          border="2px solid transparent"
          color="#03A438"
        >
          Cancel trade
        </Button>
        <Button onClick={onOpen} minW="120px !important">
          Paid
        </Button>
      </HStack>

      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        isLoading={isUpdating}
        onConfirm={handlePaid}
        title="Confirm payment"
      >
        <VStack>
          <Text textAlign="center">
            Please confirm that you have made payment of{" "}
            <strong>
              {formatter(trader?.unitToPay).format(trader?.amountToPay)}
            </strong>{" "}
            to the seller's account.
          </Text>
        </VStack>
      </ConfirmationModal>

      <ConfirmationModal
        isOpen={cancelIsOpen}
        onClose={cancelOnClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("CANCEL")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            By cancelling this order, the coins would be returned back to the
            seller, and the funds are not refundable.
          </Text>
        </VStack>
      </ConfirmationModal>

      <UploadProve
        file={file}
        isOpen={uploadProveIsOpen}
        onClose={onCloseUploadProve}
        isLoading={isUploading || isUpdating}
        onConfirm={handleUploadAndConfirmPayment}
        onFileChange={(file) => setFile(file)}
      />

      {/* <SuccessModal isOpen={} onClose={} title="Success" message="" /> */}
    </>
  );
};

const TraderSessionPaid = ({ trader, tradeId, frozenRef }) => {
  const toast = useToast();
  const { timer: countDown, expired } = useMinsCountDown(
    trader?.timeline?.dueAt,
    `${trader?.timeline?.duration}m : 00s`
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: cancelIsOpen,
    onOpen: cancelOnOpen,
    onClose: cancelOnClose,
  } = useDisclosure();

  const proofOfWaiverFileName = useMemo(() => {
    const tokens = String(trader?.proofOfWaiver).split("/");
    return tokens[tokens?.length - 1];
  }, [trader]);

  const [
    _updateTradeSession,
    { isLoading: isUpdating, isSuccess, isError, error },
  ] = useUpdateTradeSessionMutation();

  const updateSession = useCallback(
    (operation, reason = "") =>
      tradeId &&
      frozenRef &&
      _updateTradeSession({
        id: tradeId,
        frozenRef,
        operation,
        reason,
        reasonForFlag: reason,
      }),
    [tradeId, frozenRef, _updateTradeSession]
  );

  useEffect(() => {
    if (isError && error) {
      console.log("ERROR", error);
      toast({
        position: "bottom-right",
        title: "Opps",
        description: error?.data?.error,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, cancelOnClose, isError, error, toast]);
  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Paid</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
            {toUpper(trader?.unitToReceive)} to be released in:
          </Text>
          <Text fontSize="sm" color={expired ? "red.500" : "#03A438"}>
            {/* {trader?.timeline?.duration} mins */}
            {countDown}
          </Text>
        </HStack>
      </Box>

      <HStack
        mt="40px !important"
        justifyContent="center"
        gridGap="20px"
      ></HStack>

      {trader?.proofOfWaiver && (
        <Stack borderTop="1px solid #D9DBE9" p="24px 0 0 0">
          <Stack mb="20px">
            <Text fontSize="sm" mr="10px !important">
              Proof of Payment
            </Text>

            <CButton
              w="fit-content"
              leftIcon={<Box boxSize="16px" as={FileIcon} />}
              fontSize="xs"
              variant="link"
              color="#4878FF"
              _focus={{ shadow: "0 0 0 3px #06C3448f" }}
              onClick={() => window.open(trader.proofOfWaiver, "_blank")}
            >
              {proofOfWaiverFileName}
            </CButton>
          </Stack>
        </Stack>
      )}

      <HStack
        mt="40px !important"
        pb="40px"
        justifyContent="center"
        gridGap="20px"
      >
        <Button
          // h="56px"
          disabled={isUpdating}
          onClick={cancelOnOpen}
          minW="120px !important"
          // px="10px"
          bg="transparent"
          border="2px solid transparent"
          color="#03A438"
        >
          Cancel trade
        </Button>
        <Button
          disabled={isUpdating || !expired}
          isLoading={isUpdating}
          onClick={onOpen}
          minW="120px !important"
        >
          Dispute
        </Button>
      </HStack>

      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("DISPUTE", "dispute")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">Are you sure about this?</Text>
        </VStack>
      </ConfirmationModal>

      <ConfirmationModal
        isOpen={cancelIsOpen}
        onClose={cancelOnClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("CANCEL")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            By cancelling this order, the coins would be returned back to the
            seller, and the funds are not refundable.
          </Text>
        </VStack>
      </ConfirmationModal>
    </>
  );
};

const TraderSessionCompleted = ({
  trade,
  trader,
  tradeOwner,
  tradeId,
  frozenRef,
  userData,
}) => {
  const history = useHistory();

  const [_rateTrade, { isLoading: isRating }] = useRateTradeMutation();

  const rate = trade?.ratings?.find(
    (rate) => rate?.userId === userData?.userId
  );

  const rateTrade = useCallback(
    (rating) =>
      tradeId &&
      frozenRef &&
      _rateTrade({
        id: tradeId,
        frozenRef,
        rating,
      }),
    [tradeId, frozenRef, _rateTrade]
  );

  const proofOfWaiverFileName = useMemo(() => {
    const tokens =
      String(trader?.proofOfWaiver).split("/") ||
      String(tradeOwner?.proofOfWaiver).split("/");
    return tokens[tokens?.length - 1];
  }, [trader, tradeOwner]);

  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Order Completed</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
            Your order has been completed succesfully and the coins have been
            transfered to your wallet
          </Text>
        </HStack>
      </Box>

      <Stack p="20px 0" maxW="100px">
        <Button
          onClick={() => history.replace("/dashboard/wallet")}
          bg="transparent"
          minW="80px !important"
          fontSize="xs"
          fontWeight="400"
          color="#03A438"
          p="0 !important"
        >
          View wallet
        </Button>
      </Stack>

      <Stack borderTop="1px solid #D9DBE9" p="32px 0">
        {(trader?.proofOfWaiver || tradeOwner?.proofOfWaiver) && (
          <Stack mb="20px">
            <Text fontSize="sm" mr="10px !important">
              Proof of Payment
            </Text>

            <CButton
              w="fit-content"
              leftIcon={<Box boxSize="16px" as={FileIcon} />}
              fontSize="xs"
              variant="link"
              color="#4878FF"
              _focus={{ shadow: "0 0 0 3px #06C3448f" }}
              onClick={() =>
                window.open(
                  trader.proofOfWaiver || tradeOwner?.proofOfWaiver,
                  "_blank"
                )
              }
            >
              {proofOfWaiverFileName}
            </CButton>
          </Stack>
        )}
        <Stack>
          {!rate && (
            <Text fontSize="sm" color="#14142B">
              Rate this trade
            </Text>
          )}

          <Rating
            disabled={isRating || rate?.rating}
            value={rate?.rating ?? 0}
            name="order-rating"
            color="yellow"
            // defaultValue={2}
            precision={0.5}
            emptyIcon={
              <Box as={StarBorderIcon} color="#A0A3BD" fontSize="inherit" />
            }
            onChange={(event, newValue) => {
              rateTrade(newValue);
            }}
          />
        </Stack>
      </Stack>
    </>
  );
};

const TraderSellSessionCompleted = ({
  trade,
  trader,
  tradeOwner,
  tradeId,
  frozenRef,
  userData,
}) => {
  const history = useHistory();

  const [_rateTrade, { isLoading: isRating }] = useRateTradeMutation();

  const rate = trade?.ratings?.find(
    (rate) => rate?.userId === userData?.userId
  );

  const rateTrade = useCallback(
    (rating) =>
      tradeId &&
      frozenRef &&
      _rateTrade({
        id: tradeId,
        frozenRef,
        rating,
      }),
    [tradeId, frozenRef, _rateTrade]
  );

  const proofOfWaiverFileName = useMemo(() => {
    const tokens = String(tradeOwner?.proofOfWaiver).split("/");
    return tokens[tokens?.length - 1];
  }, [tradeOwner]);

  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Order Completed</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
            Order has completed succesfully and the coin has been transfered to
            your wallet
          </Text>
        </HStack>
      </Box>

      <Stack p="20px 0" maxW="100px">
        <Button
          onClick={() => history.replace("/dashboard/wallet")}
          bg="transparent"
          minW="80px !important"
          fontSize="xs"
          fontWeight="400"
          color="#03A438"
          p="0 !important"
        >
          View wallet
        </Button>
      </Stack>

      <Stack borderTop="1px solid #D9DBE9" p="32px 0">
        {tradeOwner?.proofOfWaiver && (
          <Stack mb="20px">
            <Text fontSize="sm" mr="10px !important">
              Proof of Payment
            </Text>

            <CButton
              w="fit-content"
              leftIcon={<Box boxSize="16px" as={FileIcon} />}
              fontSize="xs"
              variant="link"
              color="#4878FF"
              _focus={{ shadow: "0 0 0 3px #06C3448f" }}
              onClick={() => window.open(tradeOwner?.proofOfWaiver, "_blank")}
            >
              {proofOfWaiverFileName}
            </CButton>
          </Stack>
        )}
        <Stack>
          {!rate && (
            <Text fontSize="sm" color="#14142B">
              Rate this trade
            </Text>
          )}

          <Rating
            disabled={isRating || rate?.rating}
            value={rate?.rating ?? 0}
            name="order-rating"
            color="yellow"
            // defaultValue={2}
            precision={0.5}
            emptyIcon={
              <Box as={StarBorderIcon} color="#A0A3BD" fontSize="inherit" />
            }
            onChange={(event, newValue) => {
              rateTrade(newValue);
            }}
          />
        </Stack>
      </Stack>
    </>
  );
};

const TradeOwnerSessionRelease = ({
  data,
  trader,
  tradeId,
  refetch,
  frozenRef,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: disputeIsOpen,
    onOpen: disputeOnOpen,
    onClose: disputeOnClose,
  } = useDisclosure();

  const { isOpen: cancelIsOpen, onClose: cancelOnClose } = useDisclosure();
  // const { timer: countDown, expired } = useMinsCountDown(
  //   trader?.timeline?.dueAt,
  //   `${trader?.timeline?.duration}m : 00s`
  // );

  const { initiator } = useTradeInitiatorInfo(data);
  // console.log("TRADE DATA", data, ownerProfile, ownerName);

  const [_updateTradeSession, { isLoading: isUpdating, isSuccess }] =
    useUpdateTradeSessionMutation();

  const updateSession = useCallback(
    (operation, reason = "Payment was not received") =>
      tradeId &&
      frozenRef &&
      _updateTradeSession({
        id: tradeId,
        frozenRef,
        operation,
        reasonForFlag: reason,
        reason,
      }),
    [tradeId, frozenRef, _updateTradeSession]
  );

  const getStatus = () => {
    return `${data?.contractState}&${trader?.obligationStatus}`;
  };

  const proofOfWaiverFileName = useMemo(() => {
    const tokens = String(trader?.proofOfWaiver).split("/");
    return tokens[tokens?.length - 1];
  }, [trader]);

  useEffect(() => {
    if (isSuccess) {
      cancelOnClose();
      refetch();
    }
  }, [isSuccess, cancelOnClose, refetch]);

  const currentTradeStatus = getStatus();
  const paymentMade = useMemo(
    () => currentTradeStatus === "open&fulfilled",
    [currentTradeStatus]
  );

  return (
    <>
      <Box bg="#F4F2FF" p="28px 26px" borderRadius="6px">
        <HStack direction="row" gridGap="100px">
          <VStack alignItems="flex-start">
            <Text color="#4E4B66" fontSize="sm" mt="0px !important">
              From:
            </Text>
            <Text color="#4E4B66" fontSize="sm" mt="12px !important">
              Amount:
            </Text>
            <Text color="#4E4B66" fontSize="sm" mt="12px !important">
              Price:
            </Text>
            <Text color="#4E4B66" fontSize="sm" mt="12px !important">
              Quantity:
            </Text>
          </VStack>

          <VStack alignItems="flex-start">
            <HStack mt="0px !important">
              <HStack>
                {/* <Text fontSize="sm" mt="0 !important">
                  {initiatorName}
                </Text> */}
                <UserPopover user={initiator} />
              </HStack>
              {/* <IconButton
                size="xs"
                variant="ghost"
                aria-label="copy"
                icon={<CopyIcon color="#6E7191" />}
              /> */}
            </HStack>

            <HStack mt="12px !important">
              <Text fontSize="sm" mt="0 !important">
                {/* Guaranty Trust Bank */}
                {data?.currency && formatter(data.currency).format(data.amount)}
              </Text>
            </HStack>

            <HStack mt="12px !important" justifyContent="flex-start">
              <Text fontSize="sm">
                {data?.currency &&
                  formatter(data.currency).format(parseFloat(trader.unitCost))}
              </Text>
            </HStack>
            <HStack mt="12px !important" justifyContent="flex-start">
              <Text fontSize="sm">
                {floatString(data?.volume)} {toUpper(data?.coin ?? "")}
              </Text>
            </HStack>
          </VStack>
        </HStack>
      </Box>

      <HStack
        mt="40px !important"
        pb="40px"
        justifyContent="center"
        gridGap="20px"
      >
        {paymentMade && (
          <Button
            // h="56px"
            onClick={disputeOnOpen}
            disabled={!paymentMade || isUpdating}
            // disabled={!paymentMade || isUpdating || !expired}
            // disabled={isUpdating || !expired}
            minW="120px !important"
            // px="10px"
            bg="transparent"
            border="2px solid transparent"
            color="#03A438"
          >
            Dispute
            {/* {expired ? "Dispute" : countDown} */}
          </Button>
        )}
        <Button
          disabled={!paymentMade}
          onClick={onOpen}
          minW="120px !important"
        >
          Release
        </Button>
      </HStack>

      <Stack
        borderTop="1px solid #D9DBE9"
        p="26px 0"
        // borderBottom="1px solid #D9DBE9"
      >
        {trader?.proofOfWaiver && (
          <Stack mb="20px">
            <Text fontSize="sm" mr="10px !important">
              Proof of Payment
            </Text>

            <CButton
              w="fit-content"
              leftIcon={<Box boxSize="16px" as={FileIcon} />}
              fontSize="xs"
              variant="link"
              color="#4878FF"
              _focus={{ shadow: "0 0 0 3px #06C3448f" }}
              onClick={() => window.open(trader.proofOfWaiver, "_blank")}
            >
              {proofOfWaiverFileName}
            </CButton>
          </Stack>
        )}
        <Stack>
          <Heading fontSize="md">Listing Details</Heading>

          <Stack mt="24px !important">
            <HStack>
              <Text fontSize="sm" color="#4E4B66">
                Price
              </Text>
              <Text fontSize="sm" color="#4E4B66">
                <strong>{Number(trader.unitCost).toLocaleString()} </strong>
                <Box as="span" d="inline-block" fontSize="xs">
                  {toUpper(data?.currency)}
                </Box>
              </Text>
            </HStack>

            <HStack>
              <Text fontSize="sm" color="#4E4B66">
                Available
              </Text>
              <Text fontSize="sm" color="#4E4B66">
                <strong>
                  {floatString(data?.volume)} {toUpper(data?.coin ?? "")}
                </strong>
              </Text>
            </HStack>

            <HStack>
              <Text fontSize="sm" color="#4E4B66">
                Time limit
              </Text>
              <Text fontSize="sm" color="#4E4B66">
                <strong>{trader?.timeline?.duration} mins</strong>
              </Text>
            </HStack>

            {/* <HStack>
              <Text fontSize="sm" color="#4E4B66">
                Location
              </Text>
              <Text fontSize="sm" color="#4E4B66">
                <strong>{trader?.timeline?.duration} mins</strong>
              </Text>
            </HStack> */}
          </Stack>
        </Stack>
      </Stack>

      {/* <Stack
        borderTop="1px solid #D9DBE9"
        p="26px 0"
        borderBottom="1px solid #D9DBE9"
      >
        <Heading fontSize="md">Terms</Heading>

        <Text>{}</Text>
      </Stack> */}

      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("RELEASETRADE")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            Confirm this is not an accident and acknowledge that the{" "}
            <strong>
              {floatString(data?.volume)} {toUpper(data?.coin ?? "")}
            </strong>{" "}
            coins are not refundable.
          </Text>
        </VStack>
      </ConfirmationModal>

      <ConfirmationModal
        isOpen={cancelIsOpen}
        onClose={cancelOnClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("CANCEL")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            By cancelling this order, the coins would be returned back to the
            seller, and the funds are not refundable.
          </Text>
        </VStack>
      </ConfirmationModal>

      <ConfirmationModal
        isOpen={disputeIsOpen}
        onClose={disputeOnClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("DISPUTE", "Payment was not received")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            By disputing the payment, your coins will remain frozen until an
            admin resolves the dispute either against your claim or in your
            favour.
          </Text>
        </VStack>
      </ConfirmationModal>
    </>
  );
};

const TraderSessionRelease = ({
  data,
  trader,
  tradeOwner,
  tradeId,
  frozenRef,
  refetch,
}) => {
  const { timer: countDown, expired } = useMinsCountDown(
    trader?.timeline?.dueAt,
    `${trader?.timeline?.duration}m : 00s`
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: cancelIsOpen, onClose: cancelOnClose } = useDisclosure();
  const {
    isOpen: disputeIsOpen,
    onOpen: disputeOnOpen,
    onClose: disputeOnClose,
  } = useDisclosure();

  const [_updateTradeSession, { isLoading: isUpdating, isSuccess }] =
    useUpdateTradeSessionMutation();

  const updateSession = useCallback(
    (operation, reason = "Payment was not received") =>
      tradeId &&
      frozenRef &&
      _updateTradeSession({
        id: tradeId,
        frozenRef,
        operation,
        reasonForFlag: reason,
        reason,
      }),
    [tradeId, frozenRef, _updateTradeSession]
  );

  const getStatus = () => {
    return `${data?.contractState}&${tradeOwner?.obligationStatus}`;
  };

  useEffect(() => {
    if (isSuccess) {
      cancelOnClose();
      refetch();
    }
  }, [isSuccess, cancelOnClose, refetch]);

  const currentTradeStatus = getStatus();
  const paymentMade = currentTradeStatus === "open&fulfilled";

  const proofOfWaiverFileName = useMemo(() => {
    const tokens = String(tradeOwner?.proofOfWaiver).split("/");
    return tokens[tokens?.length - 1];
  }, [tradeOwner]);

  return (
    <>
      <Box bg="#F4F2FF" p="28px 26px" borderRadius="6px" mt="20px">
        <Stack>
          <Text fontSize="sm" fontWeight="600">
            {paymentMade
              ? "Buyer has confirmed payment"
              : "Waiting for payment"}
          </Text>
          <HStack>
            <Text fontSize="sm">
              {paymentMade
                ? expired
                  ? "Release the coins now or dispute the payment"
                  : "Release coins before:"
                : "Payment to be received in:"}
            </Text>
            {!expired && (
              <Text fontSize="sm" color={expired ? "red.500" : "#03A438"}>
                {/* {trader?.timeline?.duration} mins */}
                {countDown}
              </Text>
            )}
          </HStack>
          {paymentMade && !expired ? (
            <Text fontSize="sm">
              {
                "If you do not receive the payment after the countdown runs out, you can raise a dispute to resolve the trade manually with an admin witness."
              }
            </Text>
          ) : null}
        </Stack>
      </Box>

      {tradeOwner?.proofOfWaiver && (
        <Stack borderTop="1px solid #D9DBE9" p="24px 0 0 0">
          <Stack mb="20px">
            <Text fontSize="sm" mr="10px !important">
              Proof of Payment
            </Text>

            <CButton
              w="fit-content"
              leftIcon={<Box boxSize="16px" as={FileIcon} />}
              fontSize="xs"
              variant="link"
              color="#4878FF"
              _focus={{ shadow: "0 0 0 3px #06C3448f" }}
              onClick={() => window.open(tradeOwner?.proofOfWaiver, "_blank")}
            >
              {proofOfWaiverFileName}
            </CButton>
          </Stack>
        </Stack>
      )}

      <HStack
        mt="40px !important"
        pb="40px"
        justifyContent="center"
        gridGap="20px"
      >
        {paymentMade && expired && (
          <Button
            // h="56px"
            onClick={disputeOnOpen}
            disabled={isUpdating || !expired}
            minW="120px !important"
            // px="10px"
            bg="transparent"
            border="2px solid transparent"
            color="#03A438"
          >
            Dispute
          </Button>
        )}
        <Button
          disabled={!paymentMade}
          onClick={onOpen}
          minW="120px !important"
        >
          Release
        </Button>
      </HStack>

      {/* <Stack
        borderTop="1px solid #D9DBE9"
        p="26px 0"
        borderBottom="1px solid #D9DBE9"
      >
        <Heading fontSize="md">Terms</Heading>

        <Text>{}</Text>
      </Stack> */}

      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("RELEASETRADE")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            You are about to release a total of{" "}
            <strong>
              {floatString(data?.volume)} {toUpper(data?.coin ?? "")}
            </strong>
            . Are you sure you want to do this?
          </Text>
        </VStack>
      </ConfirmationModal>

      <ConfirmationModal
        isOpen={cancelIsOpen}
        onClose={cancelOnClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("CANCEL")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            By cancelling this order, the coins would be returned back to the
            seller, and the funds are not refundable.
          </Text>
        </VStack>
      </ConfirmationModal>

      <ConfirmationModal
        isOpen={disputeIsOpen}
        onClose={disputeOnClose}
        isLoading={isUpdating}
        onConfirm={() => updateSession("DISPUTE", "Payment was not received")}
        title="Confirm"
      >
        <VStack>
          <Text textAlign="center">
            By disputing the payment, your coins will remain frozen until an
            admin resolves the dispute either against your claim or in your
            favour.
          </Text>
        </VStack>
      </ConfirmationModal>
    </>
  );
};

const TradeOwnerSessionCompleted = ({
  data,
  tradeId,
  trader,
  tradeOwner,
  frozenRef,
  userData,
}) => {
  const history = useHistory();
  const [_rateTrade, { isLoading: isRating }] = useRateTradeMutation();

  const rate = data?.ratings?.find((rate) => rate?.userId === userData?.userId);

  const proofOfWaiverFileName = useMemo(() => {
    const tokens = String(tradeOwner?.proofOfWaiver).split("/");
    return tokens[tokens?.length - 1];
  }, [tradeOwner]);

  const rateTrade = useCallback(
    (rating) =>
      tradeId &&
      frozenRef &&
      _rateTrade({
        id: tradeId,
        frozenRef,
        rating,
      }),
    [tradeId, frozenRef, _rateTrade]
  );
  return (
    <>
      <Box
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        {/* <Heading fontSize="sm">Order Completed</Heading> */}

        <HStack>
          <Text fontSize="sm" color="#4E4B66">
            {/* {toUpper(data?.coin ?? "Coin")} has been released by the seller to
            your wallet and order has completed successfully.*/}
            The coin has been released to the buyer and the trade is completed
            successfully.
          </Text>
        </HStack>
      </Box>

      <Stack p="20px 0" maxW="100px">
        <Button
          onClick={() => history.replace("/dashboard/wallet")}
          bg="transparent"
          minW="80px !important"
          fontSize="xs"
          fontWeight="400"
          color="#03A438"
          p="0 !important"
        >
          View wallet
        </Button>
      </Stack>
      <Stack borderTop="1px solid #D9DBE9" p="32px 0">
        {tradeOwner?.proofOfWaiver && (
          <Stack mb="20px">
            <Text fontSize="sm" mr="10px !important">
              Proof of Payment
            </Text>

            <CButton
              w="fit-content"
              leftIcon={<Box boxSize="16px" as={FileIcon} />}
              fontSize="xs"
              variant="link"
              color="#4878FF"
              _focus={{ shadow: "0 0 0 3px #06C3448f" }}
              onClick={() => window.open(tradeOwner.proofOfWaiver, "_blank")}
            >
              {proofOfWaiverFileName}
            </CButton>
          </Stack>
        )}
        <Stack>
          {!rate && (
            <Text fontSize="sm" color="#14142B">
              Rate this trade
            </Text>
          )}

          <Rating
            disabled={isRating || rate?.rating}
            value={rate?.rating ?? 0}
            name="order-rating"
            color="yellow"
            // defaultValue={2}
            precision={0.5}
            emptyIcon={
              <Box as={StarBorderIcon} color="#A0A3BD" fontSize="inherit" />
            }
            onChange={(event, newValue) => {
              rateTrade(newValue);
            }}
          />
        </Stack>
      </Stack>
    </>
  );
};

const TraderSessionCancelled = ({ timeout }) => {
  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Order Cancelled</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
            You have successfully cancelled the trade, Feel free to initiate a
            new trade
          </Text>
        </HStack>
      </Box>
    </>
  );
};

// const TraderCancelledSession = ({ timeout }) => {
//   return (
//     <>
//       <Box
//         mt="32px !important"
//         border="1px solid #D9DBE9"
//         bg="#F4F2FF"
//         p="28px 26px"
//         borderRadius="6px"
//       >
//         <Heading fontSize="sm">Order Cancelled</Heading>

//         <HStack mt="12px">
//           <Text fontSize="sm" color="#4E4B66">
//             Please ensure payment is made within {timeout}:00 mins, else
//             transaction would be cancelled.
//           </Text>
//         </HStack>
//       </Box>
//     </>
//   );
// };

const TradeOwnerCancelledSession = ({ timeout }) => {
  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Order Cancelled</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
            Order has been cancelled
          </Text>
        </HStack>
      </Box>
    </>
  );
};

const TraderSessionTimedout = ({ timeout }) => {
  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Order Timedout</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
            Order timedout.
          </Text>
        </HStack>
      </Box>
    </>
  );
};

const TradeSessionInDispute = () => {
  return (
    <>
      <Box
        mt="32px !important"
        border="1px solid #D9DBE9"
        bg="#F4F2FF"
        p="28px 26px"
        borderRadius="6px"
      >
        <Heading fontSize="sm">Order In Dispute</Heading>

        <HStack mt="12px">
          <Text fontSize="sm" color="#4E4B66">
            This trade is currently in dispute
          </Text>
        </HStack>
      </Box>
    </>
  );
};

// const TradeOwner = () => {
//   return (
//     <Box>
//       <Heading>For the Trade Owner</Heading>
//     </Box>
//   );
// };

const Trader = ({
  data,
  userData,
  refetch,
  isLoading,
  chatState,
  setChatState,
}) => {
  const { id } = useParams();
  const { onCopy } = useCopy(data?.id ?? "");
  const [tradeId, frozenRef] = (data && String(id).split("-")) ?? [];

  const tradeOwner = useMemo(
    () => data?.counterParties?.find((cp) => toLower(cp.role) === "tradeowner"),
    [data?.counterParties]
  );

  const trader = useMemo(
    () => data?.counterParties?.find((cp) => toLower(cp.role) === "trader"),
    [data?.counterParties]
  );

  const getStatus = useCallback(
    (role) => {
      const map = { trader, tradeowner: tradeOwner };
      return `${data?.contractState}&${map[role]?.obligationStatus}`;
    },
    [trader, tradeOwner, data]
  );

  const appropriateSessionOwner = useMemo(() => {
    return data?.counterParties?.find(
      (cp) => cp.user.userId === userData.userId
    );
  }, [data, userData]);

  const mapStatusToComponent = useCallback(
    (status) => {
      const map = {
        trader: {
          selling: {
            "open&pending": (
              <TraderSessionUnpaid
                trader={trader}
                tradeOwner={tradeOwner}
                tradeId={tradeId}
                frozenRef={frozenRef}
                refetch={refetch}
              />
            ),
            "open&fulfilled": (
              <TraderSessionPaid
                trader={trader}
                tradeId={tradeId}
                frozenRef={frozenRef}
              />
            ),
            "closed&fulfilled": (
              <TraderSessionCompleted
                trade={data}
                trader={trader}
                tradeId={tradeId}
                tradeOwner={tradeOwner}
                frozenRef={frozenRef}
                userData={userData}
              />
            ),
            "cancelled&pending": (
              <TraderSessionCancelled timeout={trader?.timeline?.duration} />
            ),
            "cancelled&fulfilled": (
              <TraderSessionCancelled timeout={trader?.timeline?.duration} />
            ),
            "timeout&pending": (
              <TraderSessionTimedout />
              // <TraderSessionCancelled timeout={trader?.timeline?.duration} />
              // <TraderSessionUnpaid
              //   trader={trader}
              //   tradeId={tradeId}
              //   frozenRef={frozenRef}
              // />
            ),
            "timeout&fulfilled": (
              <TraderSessionTimedout timeout={trader?.timeline?.duration} />
            ),
            "indispute&fulfilled": <TradeSessionInDispute />,
            "indispute&pending": <TradeSessionInDispute />,
          },
          buying: {
            "open&fulfilled": (
              <TraderSessionRelease
                data={data}
                trader={trader}
                tradeOwner={tradeOwner}
                tradeId={tradeId}
                frozenRef={frozenRef}
                refetch={refetch}
              />
            ),
            "open&pending": (
              <TraderSessionRelease
                data={data}
                trader={trader}
                tradeOwner={tradeOwner}
                tradeId={tradeId}
                frozenRef={frozenRef}
                refetch={refetch}
              />
            ),
            "closed&fulfilled": (
              <TraderSellSessionCompleted
                trade={data}
                trader={trader}
                tradeOwner={tradeOwner}
                tradeId={tradeId}
                frozenRef={frozenRef}
                userData={userData}
              />
            ),
            "timeout&pending": <TraderSessionTimedout />,
            "timeout&fulfilled": <TraderSessionTimedout />,

            "indispute&fulfilled": <TradeSessionInDispute />,
            "indispute&pending": <TradeSessionInDispute />,
          },
        },
        tradeowner: {
          selling: {
            "open&pending": (
              <TradeOwnerSessionRelease
                data={data}
                trader={trader}
                tradeId={tradeId}
                frozenRef={frozenRef}
                refetch={refetch}
              />
            ),
            "closed&fulfilled": (
              <TradeOwnerSessionCompleted
                data={data}
                trader={trader}
                tradeOwner={tradeOwner}
                userData={userData}
                tradeId={tradeId}
                frozenRef={frozenRef}
              />
            ),
            "open&fulfilled": (
              <TradeOwnerSessionCompleted
                data={data}
                trader={trader}
                tradeOwner={tradeOwner}
                userData={userData}
                tradeId={tradeId}
                frozenRef={frozenRef}
              />
            ),
            "cancelled&pending": (
              <TradeOwnerCancelledSession
                timeout={tradeOwner?.timeline?.duration}
              />
            ),
            "timeout&pending": (
              <TraderSessionTimedout />
              // <TradeOwnerSessionRelease
              //   data={data}
              //   trader={trader}
              //   tradeId={tradeId}
              //   frozenRef={frozenRef}
              // />
            ),
            "indispute&fulfilled": <TradeSessionInDispute />,
            "indispute&pending": <TradeSessionInDispute />,
          },
          buying: {
            "open&pending": (
              <TraderSessionUnpaid
                trader={tradeOwner}
                tradeId={tradeId}
                frozenRef={frozenRef}
                refetch={refetch}
              />
            ),
            "open&fulfilled": (
              <TraderSessionPaid
                trader={tradeOwner}
                tradeId={tradeId}
                frozenRef={frozenRef}
              />
            ),
            "closed&fulfilled": (
              <TradeOwnerSessionCompleted
                data={data}
                trader={trader}
                userData={userData}
                tradeId={tradeId}
                tradeOwner={tradeOwner}
                frozenRef={frozenRef}
              />
            ),
            "indispute&fulfilled": <TradeSessionInDispute />,
            "indispute&pending": <TradeSessionInDispute />,
          },
        },
      };

      return map[appropriateSessionOwner?.role][data?.adsType][status];
    },
    [
      trader,
      tradeId,
      frozenRef,
      appropriateSessionOwner,
      data,
      tradeOwner,
      userData,
      refetch,
    ]
  );

  const isSessionActive = (role) =>
    getStatus(role) &&
    getStatus(role) !== "cancelled&pending" &&
    getStatus(role) !== "closed&fulfilled" &&
    getStatus(role) !== "timeout&pending";

  const tradeType = useMemo(() => {
    const map = {
      trader: { selling: "Buy", buying: "Sell" },
      tradeowner: { selling: "Sell", buying: "Buy" },
    };
    return map[
      tradeOwner?.user?.userId === userData?.userId ? "tradeowner" : "trader"
    ][data?.adsType];
  }, [data, tradeOwner, userData?.userId]);

  console.log("TRADE TYPE", tradeOwner);

  // console.log(
  //   "APPROPRIATE SESSION OWNER",
  //   appropriateSessionOwner,
  //   getStatus(appropriateSessionOwner?.role)
  // );

  return (
    <>
      {/* {isLoading && (
        <CircularProgress isIndeterminate size="20px" color="green" />
      )} */}

      {!isLoading && (
        <Container maxW={["100%", "container.xl"]} p={["0", "0", "1rem"]}>
          <Box px={["24px", "0", "0"]}>
            <Heading fontSize="3xl">
              {tradeType} {toUpper(data?.coin ?? "")}
            </Heading>

            <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
              <BreadcrumbItem>
                <BreadcrumbLink to="/dashboard/p2p">P2P</BreadcrumbLink>
              </BreadcrumbItem>

              <BreadcrumbItem>
                <BreadcrumbLink to="/dashboard/p2p/trades">
                  Trade history
                </BreadcrumbLink>
              </BreadcrumbItem>

              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink isCurrentPage href="#">
                  Order
                </BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
          </Box>

          <Grid
            templateColumns={["1fr", "", ".55fr .4fr"]}
            overflow="hidden"
            mt={["24px", "48px"]}
            gridGap="20px"
          >
            <Box bg="white" borderRadius={[0, "16px"]} h="fit-content">
              <HStack
                alignItems="flex-start"
                gridGap={["8px", "32px"]}
                p={["20px 24px", "20px 32px"]}
                borderBottom="1px solid #D9DBE9"
                flexDir={["column", "row"]}
                pos="relative"
              >
                <IconButton
                  d={["inline-flex", "inline-flex", "inline-flex", "none"]}
                  size="sm"
                  variant="ghost"
                  aria-label="copy"
                  icon={
                    <Box as={MessengerIcon} boxSize="18px" color="#6E7191" />
                  }
                  pos="absolute"
                  right={["24px", "24px", "32px", "0"]}
                  top={["unset", "10px", "50%", "50%"]}
                  bottom={["16px"]}
                  transform={["unset", "unset", "unset", "translateY(-50%)"]}
                  _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                />

                <Stack
                  flexDir={["row", "column"]}
                  ml={["0 !important", "0.5rem"]}
                >
                  <Text color="#4E4B66" fontSize="sm">
                    Date
                  </Text>
                  <Text
                    fontSize="sm"
                    mt="0px !important"
                    ml={["20px !important", "0 !important", "10px"]}
                  >
                    {/* 17-06-2021 */}

                    {data && format(parseISO(data?.createdAt), "dd-MM-yyy")}
                  </Text>
                </Stack>
                <Stack
                  flexDir={["row", "column"]}
                  ml={["0 !important", "0.5rem"]}
                >
                  <Text color="#4E4B66" fontSize="sm">
                    Time
                  </Text>
                  <Text
                    fontSize="sm"
                    mt="0px !important"
                    ml={["20px !important", "0 !important", "10px"]}
                  >
                    {data && format(parseISO(data?.createdAt), "HH:mm")}
                  </Text>
                </Stack>
                <Stack
                  flexDir={["row", "column"]}
                  ml={["0 !important", "0.5rem"]}
                >
                  <Text color="#4E4B66" fontSize="sm">
                    ID
                  </Text>
                  <HStack
                    mt={["-2px !important", "0 !important", "0px !important"]}
                    ml={["20px !important", "0 !important", "10px"]}
                  >
                    <Text fontSize="sm">{data?.id}</Text>
                    <IconButton
                      size="xs"
                      variant="ghost"
                      aria-label="copy"
                      icon={<CopyIcon />}
                      onClick={onCopy}
                      _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                    />
                  </HStack>
                </Stack>
              </HStack>

              <Stack p={["24px", "32px"]}>
                <HStack alignItems="flex-start" justifyContent="space-between">
                  <Stack>
                    <Text color="#4E4B66" fontSize="sm">
                      Amount
                    </Text>
                    <Text fontSize="sm" fontWeight="bold" mt="0px !important">
                      {/* ₦12,000 */}
                      {data &&
                        formatter(data?.currency).format(data?.amount)}{" "}
                    </Text>
                  </Stack>
                  <Stack>
                    <Text color="#4E4B66" fontSize="sm">
                      Quantity
                    </Text>
                    <Text fontSize="sm" mt="0px !important">
                      {floatString(data?.volume)} {toUpper(data?.coin ?? "")}
                    </Text>
                  </Stack>
                  <Stack>
                    <Text color="#4E4B66" fontSize="sm">
                      Transaction Fee
                    </Text>
                    <Text mt="0px !important" fontSize="sm">
                      {/* 19,190,000.00 */}
                      {floatString(trader?.tradeFee)}{" "}
                      {toUpper(data?.coin ?? "")}
                    </Text>
                  </Stack>
                </HStack>

                {mapStatusToComponent(getStatus(appropriateSessionOwner?.role))}
              </Stack>
            </Box>

            {tradeId && frozenRef && (
              <Box d={["none", "none", "block"]}>
                <Messanger
                  sessionActive={isSessionActive("trader")}
                  tradeId={tradeId}
                  frozenRef={frozenRef}
                  trader={trader}
                  tradeOwner={tradeOwner}
                  chatState={chatState}
                  setChatState={setChatState}
                />
              </Box>
            )}
          </Grid>
        </Container>
      )}
    </>
  );
};

const TradeSession = (props) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const { id } = useParams();
  const {
    store: { userData },
  } = useStore();

  console.log("PROPS", props);

  const tokenRef = useRef(null);

  useEffect(() => {
    const auth = ls.get(constant.AUTH_TOKEN_KEY);
    const token = auth.token;
    tokenRef.current = token;
  }, []);

  const {
    data: _data,
    isLoading,
    refetch,
    isFetching,
  } = useGetBuyTradeSessionQuery(id, {
    pollingInterval: isCompleted ? 0 : 0,
  });

  const [data, setData] = useState(_data);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setData(_data);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isFetching]);

  const [chatState, setChatState] = useState({
    chatOpened: false,
    chatInFocus: false,
    unReadChats: [],
  });

  const applyContractUpdate = useCallback((data) => {
    setData(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const watchChats = useCallback(
    (data) => {
      if (data?.username === userData?.username) return;
      if (chatState.chatOpened) {
        if (chatState.chatInFocus) {
        } else {
          setChatState((p) => ({
            ...p,
            unReadChats: p?.unReadChats.concat(data),
          }));
        }
      } else {
        setChatState((p) => ({
          ...p,
          unReadChats: p?.unReadChats.concat(data),
        }));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [chatState?.unReadChats?.length, chatState?.chatOpened]
  );

  const tradeUpdateHandlers = useMemo(
    () => ({
      "trade-update": {
        register: true,
        do: applyContractUpdate,
      },
      "test-event": {
        register: true,
        do: (d) => {
          console.log({ d });
        },
      },
      "chat-update": {
        register: true,
        do: watchChats,
      },
    }),
    [applyContractUpdate, watchChats]
  );

  usePusher({
    accessKey: tokenRef.current,
    channelName: id,
    handlers: tradeUpdateHandlers,
    endpoint: "p2p/realtime/trade/auth",
    skip: !tokenRef.current,
  });

  useEffect(() => {
    if (
      data?.contractState === "closed" ||
      data?.contractState === "timeout" ||
      data?.contractState === "cancelled"
      // getStatus() === "open&fulfilled"
    ) {
      // set to true to disable polling when trade is closed, timedout or cancelled
      setIsCompleted(true);
    }
  }, [data]);

  // console.group("Trade Session Logs");
  // console.log("SESSION DATA", data, userData);
  // console.log(
  //   "Trade Owner",
  //   data?.adsType,
  //   ":: ORIGINAL OWNER :: ",
  //   data?.originalOwner,
  //   ":: USER ID :: ",
  //   userData?.userId
  // );
  // console.log(
  //   "Trader",
  //   data?.adsType,
  //   ":: ORIGINATING PARTY :: ",
  //   data?.originatingParty,
  //   ":: USER ID :: ",
  //   userData?.userId
  // );

  const mapScreen = (key, props = {}) => {
    const map = {
      [`buying-${data?.originalOwner}`]: (
        <Trader refetch={refetch} {...props} />
      ),
      [`buying-${data?.originatingParty}`]: (
        <Trader refetch={refetch} {...props} />
      ),
      [`selling-${data?.originalOwner}`]: (
        <Trader refetch={refetch} {...props} />
      ),
      [`selling-${data?.originatingParty}`]: (
        <Trader refetch={refetch} {...props} />
      ),
    };

    return map[key];
  };

  const mapKey = useMemo(
    () => `${data?.adsType}-${userData?.userId}`,
    [data, userData]
  );

  console.log("GOOT HERE!!!", mapKey);
  console.groupEnd();

  return (
    <Box
      __css={{
        "--color": "#4E4B66",
        "--borderColor": "#D9DBE9",
        "--focusColor": "#06c34491",
        "--primary": "#03A438",
      }}
    >
      <Sidemenu currentPage="P2P" logoutUser={props?.logout} />
      <Header />

      <Box className="p2p">
        <Box
          className="p2p-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW={["100%", "container.xl"]} p={["0", "0", "1rem"]}>
            {isLoading && (
              <CircularProgress isIndeterminate size="20px" color="green" />
            )}
            {/* <Heading fontSize="3xl">Trade Session</Heading> */}

            {data &&
              mapScreen(mapKey, {
                data,
                userData,
                isLoading,
                chatState,
                setChatState,
              })}
            {/* <Text>{data?.adsType ?? ""}</Text> */}
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default TradeSession;
